import { render, staticRenderFns } from "./carDispatchForm.vue?vue&type=template&id=5a9e1d36&scoped=true"
import script from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
export * from "./carDispatchForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./carDispatchForm.vue?vue&type=style&index=0&id=5a9e1d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e1d36",
  null
  
)

export default component.exports